import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer-custom">
      <div className="footer-row">
        <div className="footer-brand">
          <img src="/icon/sculkmc.png" alt="" />
          <span className="brand-word" lang="en">SculkMC</span>
        </div>

        <div className="footer-center">
          <span className="footer-copyright">© {new Intl.DateTimeFormat('fa-IR', { year: 'numeric' }).format(new Date())} · SculkMC · تمام حقوق محفوظ است.</span>
          <a className="footer-credit" href="https://hooman009.ir" target="_blank" rel="noopener noreferrer" lang="en" dir="ltr">
            remake with 💙 by hooman009
          </a>
        </div>

        <div className="footer-left">
          <a
            href="https://www.youtube.com/@H.Skarfin"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-icon footer-social-icon--youtube"
            aria-label="YouTube"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z" />
            </svg>
          </a>
          <a
            href="/discord"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-icon footer-social-icon--discord"
            aria-label="Discord"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.3 4.4A19.6 19.6 0 0 0 15.5 3l-.2.4c-.2.4-.4.8-.5 1.2a18.2 18.2 0 0 0-5.6 0 9 9 0 0 0-.7-1.6 19.6 19.6 0 0 0-4.8 1.4C.7 8.9-.1 13.2.3 17.4A19.9 19.9 0 0 0 6.2 20.4c.5-.7.9-1.4 1.2-2.2-.7-.3-1.4-.6-2-1l.5-.4a14.1 14.1 0 0 0 12.2 0l.5.4c-.6.4-1.3.8-2 1 .3.8.7 1.5 1.2 2.2a19.8 19.8 0 0 0 5.9-2.9c.5-4.9-.8-9.1-3.4-13.1ZM8 14.8c-1.1 0-2-1-2-2.2 0-1.2.9-2.2 2-2.2s2 1 2 2.2c0 1.2-.9 2.2-2 2.2Zm8 0c-1.1 0-2-1-2-2.2 0-1.2.9-2.2 2-2.2s2 1 2 2.2c0 1.2-.9 2.2-2 2.2Z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
